<div class="signup-container">
  @if (isLoading$ | async) {
    <div class="signup-additional-info-retry-container">
      @if ((queryTokenInvalid$ | async) === false) {
        <mat-spinner></mat-spinner>
      }
      @if (queryTokenFailed$ | async) {
        <div class="signup-additional-info-retry">
          <span class="signup-additional-info-retry-text" i18n
            >Informationen konnten nicht geladen werden.</span
          >
          <button
            mat-raised-button
            color="primary"
            (click)="retryLoadingToken()"
            i18n
          >
            Erneut versuchen
          </button>
        </div>
      }
      @if (queryTokenInvalid$ | async) {
        <div class="signup-additional-info-invalid">
          <img
            src="assets/images/blankmile-logo-1x.webp"
            class="signup-additional-info-invalid-logo"
            alt="blankmile Logo"
          />
          <span class="signup-additional-info-invalid-text" i18n
            >Der verwendete Token ist nicht mehr gültig. <br />Entweder er ist
            abgelaufen oder Ihr Administrator hat die Einladung
            zurückgezogen.</span
          >
          <span class="signup-additional-info-invalid-support" i18n
            >Falls es sich um einen Fehler handelt, melden Sie sich unter
            <a href="mailto:support@blankmile.com">support&#64;blankmile.com</a>
          </span>
        </div>
      }
    </div>
  } @else {
    <div class="signup-additional-info-container">
      <div class="signup-additional-info-description-container">
        <img
          class="signup-additional-info-company-logo"
          src="{{
            (companyInfo$ | async)?.logoUrl ??
              'assets/images/blankmile-logo-1x.webp'
          }}"
          i18n-alt
          alt="Das Logo Ihres Unternehmens"
        />
        <span class="signup-additional-info-description" i18n
          ><b>{{ (companyInfo$ | async)?.displayName }}</b> hat Sie eingeladen
          <b>blankmile</b> zu verwenden.<br />Ergänzen Sie hier Ihre
          Anmeldeinformationen,<br />Sie werden anschließend zur Anwendung
          weitergeleitet.</span
        >
      </div>
      <form
        [formGroup]="signUpInformationFormGroup"
        class="signup-additional-info-form"
      >
        <h1 i18n>Anmeldeinformationen vervollständigen</h1>
        <mat-form-field appearance="outline" disabled="true">
          <mat-label>Email</mat-label>
          <input formControlName="email" matInput type="text" />
        </mat-form-field>
        <div class="signup-additional-info-form-phone-container">
          <app-phone-number-input
            class="signup-additional-info-form-phone-number-input"
            (phoneNumberChanged)="onPhoneNumberChanged($event)"
            (phoneNumberVerifiedChanged)="onPhoneNumberVerifiedChanged($event)"
            [favoriteCountryCodeSet]="defaultFavoriteCountryCodeSet"
          >
          </app-phone-number-input>
          @if (phoneNumberVerified$ | async) {
            <mat-icon class="signup-additional-info-form-phone-verified">
              check
            </mat-icon>
          } @else {
            <mat-icon class="signup-additional-info-form-phone-not-verified"
              >clear</mat-icon
            >
          }
        </div>
        <div class="signup-additional-info-form-name-container">
          <mat-form-field
            appearance="outline"
            class="signup-additional-info-form-first-name"
          >
            <mat-label i18n>Vorname</mat-label>
            <input formControlName="firstName" matInput type="text" />
            <mat-error i18n> Vorname darf nicht leer sein </mat-error>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            class="signup-additional-info-form-last-name"
          >
            <mat-label i18n>Nachname</mat-label>
            <input formControlName="lastName" matInput type="text" />
            <mat-error i18n> Nachname darf nicht leer sein </mat-error>
          </mat-form-field>
        </div>
        <mat-form-field appearance="fill">
          <mat-label i18n>Passwort eingeben</mat-label>
          <input
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            matInput
          />
          <button
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hidePassword"
            mat-icon-button
            matSuffix
            tabindex="-1"
          >
            <mat-icon>{{
              hidePassword ? "visibility_off" : "visibility"
            }}</mat-icon>
          </button>
          @if (
            signUpInformationFormGroup.controls.password.hasError(
              signUpValidationMessages.passwordRequired.errorCode
            ) &&
            (signUpInformationFormGroup.controls.password.dirty ||
              signUpInformationFormGroup.controls.password.touched)
          ) {
            <mat-error>{{
              signUpValidationMessages.passwordRequired.message
            }}</mat-error>
          }
          @if (
            signUpInformationFormGroup.controls.password.hasError(
              signUpValidationMessages.passwordTooShort.errorCode
            ) &&
            (signUpInformationFormGroup.controls.password.dirty ||
              signUpInformationFormGroup.controls.password.touched)
          ) {
            <mat-error>{{
              signUpValidationMessages.passwordTooShort.message
            }}</mat-error>
          }
          @if (
            signUpInformationFormGroup.controls.password.hasError(
              signUpValidationMessages.passwordBlacklisted.errorCode
            ) &&
            (signUpInformationFormGroup.controls.password.dirty ||
              signUpInformationFormGroup.controls.password.touched)
          ) {
            <mat-error>{{
              signUpValidationMessages.passwordBlacklisted.message
            }}</mat-error>
          }
          @if (
            signUpInformationFormGroup.controls.password.hasError(
              "passwordPolicy"
            )
          ) {
            <mat-error>{{
              signUpValidationMessages.passwordPolicy.message
            }}</mat-error>
          }
          @if (
            signUpInformationFormGroup.controls.password.hasError(
              "passwordValidationUnavailable"
            )
          ) {
            <mat-error>{{
              signUpValidationMessages.passwordValidationUnavailable.message
            }}</mat-error>
          }
        </mat-form-field>
        <button
          type="submit"
          mat-raised-button
          color="primary"
          [disabled]="!signUpInformationFormGroup.valid"
          (click)="sendAdditionalInformation()"
          i18n
        >
          Anmeldung vervollständigen
        </button>
      </form>
    </div>
  }
</div>
